export const PILLARS = [
  { id: 0, name: 'Inclusion', question: '"Do I belong here?"' },
  { id: 1, name: 'Advancement', question: '"Can I grow here?"' },
  { id: 2, name: 'Compensation', question: '"Am I treated fairly?"' },
  { id: 3, name: 'Representation', question: '"Am I seen for who I am?"' },
  { id: 4, name: 'Psychological Safety', question: '"Can I speak honestly without fear?"' },
  { id: 5, name: 'Emotional Intelligence', question: '"Can we handle difficult conversations?"' },
];

export const PILLAR_QUESTION_MAP: Record<string, string> = PILLARS.reduce((map, pillar) => {
  map[pillar.name] = pillar.question;
  return map;
}, {} as Record<string, string>);
